<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar flat>
                    <v-toolbar-title>{{ game.title }}</v-toolbar-title>

                    <v-spacer/>

                    <game-menu :game="game"/>
                </v-toolbar>

                <v-card flat tile>
                    <v-card-text>
                        <div class="body-1">
                            <strong>Invite link:</strong>
                            {{ `https://eldritchhorror.rickardfransen.se/game/${game.id}/join/${game.invite_code}` }}
                            <v-btn icon
                                   v-clipboard:copy="`https://eldritchhorror.rickardfransen.se/game/${game.id}/join/${game.invite_code}`"
                                   v-clipboard:success="function () { copied = true; }">
                                <v-icon v-if="copied" color="green">mdi-clipboard-check-multiple-outline</v-icon>
                                <v-icon v-else>mdi-clipboard-multiple-outline</v-icon>
                            </v-btn>
                        </div>
                        <div class="caption">
                            Use the invitation link above to let other users join your game with their user account.
                            When a user is logged in, have them follow the link above and they will be able to access
                            your game.
                        </div>
                    </v-card-text>
                </v-card>

                <v-card flat tile>
                    <v-card-title>Expansions</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-checkbox v-for="(gamePack, gamePackIndex) in gamePacks"
                                            :key="'gamePack' + gamePackIndex"
                                            :value="gamePack.id"
                                            v-model="gamePackSelection"
                                            hide-details
                                            dense
                                            :label="gamePack.title"/>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col>
                                Card count: {{ game.total_card_count }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <v-card flat tile>
                    <v-card-title>Add Investigator</v-card-title>
                    <v-card-text>
                        <v-row no-gutters>
                            <v-col cols="12"
                                   sm="6">
                                <v-col cols="12">
                                    <v-select hide-details
                                              label="Investigator"
                                              :items="game.available_investigators"
                                              v-model="form.investigator_id"
                                              item-value="id"
                                              item-text="title"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-btn text
                                           class="pl-0"
                                           color="secondary"
                                           @click="$router.push({name: 'pick-investigator'})">Extended Selection
                                    </v-btn>
                                </v-col>

                            </v-col>
                            <v-col>

                                <v-col>
                                    <v-select hide-details
                                              label="After Investigator"
                                              :items="game.activeInvestigatorSessions"
                                              v-model="form.investigator_session_id"
                                              item-value="id"
                                              item-text="investigator.title"/>
                                </v-col>
                                <v-col class="text-end">
                                    <v-btn text
                                           color="primary"
                                           @click="storeInvestigatorSession">Add Investigator
                                    </v-btn>
                                </v-col>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-snackbar v-model="snackbar"
                    :timeout="2000">
            Investigator {{ lastInvestigator.investigator.title }} added.
            <v-btn color="blue"
                   text
                   @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
  import GameService from "../services/GameService";
  import InvestigatorSessionService from "../services/InvestigatorSessionService";
  import GamePackService from "../services/GamePackService";
  import GameMenu from "./GameMenu";

  export default {
    components: {
      GameMenu
    },

    data: () => ({
      form: {
        investigator_id: null,
        investigator_session_id: null
      },
      gamePackSelection: [],
      copied: false,
      snackbar: false,
      lastInvestigator: {
        investigator: {
          title: null
        }
      }
    }),

    computed: {
      game() {
        return this.$store.getters.game;
      },

      gamePacks() {
        return this.$store.getters.gamePacks;
      }
    },

    created() {
      if (this.$store.getters.game.game_pack_selection) {
        this.gamePackSelection = this.$store.getters.game.game_pack_selection;
      }

      this.viewGame();
      this.indexGamePacks();

      if (this.$route.params.investigatorId) {
        this.form.investigator_id = this.$route.params.investigatorId;
      }
    },

    watch: {
      gamePackSelection: function (val) {
        this.setGamePackSelection(val);
      }
    },

    methods: {
      viewGame() {
        GameService.view(this.$route.params.gameId)
          .then(response => {
            this.$store.dispatch("setGameId", response.data.data.id);
            this.$store.dispatch("setGame", response.data.data);
            this.gamePackSelection = this.game.game_pack_selection;
            if (this.$store.getters.game.activeInvestigatorSessions.length) {
              this.form.investigator_session_id = this.$store.getters.game.activeInvestigatorSessions[this.$store.getters.game.activeInvestigatorSessions.length - 1].id;
            }
          })
          .catch(() => {
            this.$router.push({name: "home"});
          });
      },

      indexGamePacks() {
        GamePackService.index()
          .then(response => {
            this.$store.dispatch("setGamePacks", response.data.data);
          });
      },

      storeInvestigatorSession() {
        this.form.game_id = this.$route.params.gameId;

        InvestigatorSessionService.store(this.form)
          .then(response => {
            this.form.investigator_id = null;
            this.lastInvestigator = response.data.data;
            this.snackbar = true;
            this.viewGame();
          });
      },

      setGamePackSelection(val) {
        GameService.setGamePackSelection(this.game.id, val)
          .then(response => {
            this.$store.dispatch("setGame", response.data.data);
          });
      }
    }
  };
</script>
